<template>
  <GenericModal
    size="modal-fullscreen"
    :show="show"
    :showHeader="false"
    :options="{ background: 'black' }"
  >
    <template #default>
      <cropper
        v-if="show"
        :src="imgToEdit"
        :default-size="defaultSize"
        ref="imageEditor"
        default-boundaries="fit"
        :auto-zoom="false"
        image-restriction="fit-area"
      />
        <div class="image-editor-controls">
            <button type="button" @click="rotate(-90)"><i class="fas fa-rotate-left"></i></button>
            <button type="button" @click="rotate(90)"><i class="fas fa-rotate-right"></i></button>
            <button type="button" @click="flip(true, false)"><i class="fas fa-arrows-left-right"></i></button>
            <button type="button" @click="flip(false, true)"><i class="fas fa-arrows-up-down"></i></button>
            <div class="slider vertical-slider">
          <input
            type="range"
            min="0"
            max="200"
            v-model="imageBrightness"
            @input="applyBrightness"
          >
                <span><i class="fas fa-sun"></i> {{ imageBrightness }}</span>
            </div>
            <div class="slider vertical-slider">
          <input
            type="range"
            min="0"
            max="200"
            v-model="imageContrast"
            @input="applyContrast"
          >
                <span><i class="fas fa-circle-half-stroke"></i> {{ imageContrast }}</span>
            </div>
        <button type="button" @click="save"><i class="fas fa-save"></i></button>
        <button type="button" @click="close"><i class="fas fa-close"></i></button>
        </div>
    </template>
</GenericModal>
</template>

<script lang="ts" setup>
import { ref, watch, nextTick } from 'vue'
// @ts-ignore
import GenericModal from '@/components/generic-modal'
// @ts-ignore
import { Cropper } from '../lib/index.esm-browser'
import '../lib/style.css'

interface Props {
  media?: any
  imgToEdit?: string
  show: boolean
  fileName?: string
}

const props = defineProps<Props>()
const emit = defineEmits(['saveImage', 'closeImageEditor'])

const imageEditor = ref<InstanceType<typeof Cropper> | null>(null)
const imageBrightness = ref(100)
const imageContrast = ref(100)

watch(() => props.show, (newVal) => {
  if (newVal) initEditor()
})

const initEditor = () => {
  imageBrightness.value = 100
  imageContrast.value = 100
  imageEditor.value?.onChangeImage()
}
const rotate = (angle: number) => {
  if (!imageEditor.value) return

  imageEditor.value.rotate(angle)
  nextTick(() => {
    if (!imageEditor.value) return
    imageEditor.value.transitionsActive = false
        imageEditor.value.setCoordinates({
            top: 0,
            left: 0,
            height: imageEditor.value.imageSize.height,
            width: imageEditor.value.imageSize.width
    })
  })
}

const applyBrightness = () => {
  if (!imageEditor.value) return

  imageEditor.value.brightness(imageBrightness.value)
  nextTick(() => {
    if (!imageEditor.value) return
    imageEditor.value.transitionsActive = false
        imageEditor.value.brightness(imageBrightness.value)
  })
}

const applyContrast = () => {
  if (!imageEditor.value) return

  imageEditor.value.contrast(imageContrast.value)
  nextTick(() => {
    if (!imageEditor.value) return
    imageEditor.value.transitionsActive = false
        imageEditor.value.contrast(imageContrast.value)
  })
}

const flip = (x: boolean, y: boolean) => {
  if (!imageEditor.value) return

  const { image } = imageEditor.value.getResult()
    if (image.transforms.rotate % 180 !== 0) {
    imageEditor.value.flip(!x, !y)
    } else {
    imageEditor.value.flip(x, y)
    }
}

const defaultSize = ({ imageSize, visibleArea }: {
  imageSize?: { width: number, height: number },
  visibleArea?: { width: number, height: number }
}) => ({
  width: (imageSize || visibleArea)?.width || 0,
  height: (imageSize || visibleArea)?.height || 0
})
const save = () => {
  //if (!imageEditor.value || !props.fileName) return
  const { canvas } = imageEditor.value.getResult()
  canvas.toBlob((blob: BlobPart) => {
    if (!blob) return
    const file = new File([blob], props.fileName)
    emit('saveImage', file)
  })
}

const close = () => {
  emit('closeImageEditor')
}
</script>

<style scoped>
.slider {
  position: relative;
}

.slider span {
  position: absolute;
  color: white;
}

.slider.vertical-slider span {
  top: calc(50% - 15px);
  left: 20px;
  width: 50px;
}

.slider.vertical-slider input[type="range"] {
  writing-mode: vertical-lr;
}
</style>
